import dayjs, { Dayjs } from 'dayjs';
import { ActivityTypeEnum } from '../components/organisms/activities/activities.types';
import { ApiRoutes } from '../constants/api-routes.constants';

export function getCookie(name: string): string | null {
  const nameLenPlus = name.length + 1;
  return (
    document.cookie
      .split(';')
      .map((c) => c.trim())
      .filter((cookie) => {
        return cookie.substring(0, nameLenPlus) === `${name}=`;
      })
      .map((cookie) => {
        return decodeURIComponent(cookie.substring(nameLenPlus));
      })[0] || null
  );
}

export function getDate(value: string, format = 'YYYY-MM-DD'): Dayjs {
  return dayjs(value, format);
}

export function getTime(value: string, format = 'HH:mm'): Dayjs {
  return dayjs(value, format);
}

export function setTimeOnDate(date: Dayjs, time: Dayjs): Dayjs {
  return date.clone().add(time.get('hour'), 'hour').add(time.get('minutes'), 'minutes');
}

export function createEndpointUrl(path: string, params?: Record<string, string>): string {
  const paramKeys = Object.keys(params ?? []);

  const adaptedPath = paramKeys.reduce((tmpPath, key) => {
    const encodedValue = encodeURIComponent(params![key]);
    return tmpPath.replace(`{${key}}`, encodedValue);
  }, path);

  return `${window.location.origin}/${ApiRoutes.basePath}${adaptedPath}`;
}

export const getActivityTypeLabel: Record<ActivityTypeEnum, string> = {
  [ActivityTypeEnum.BOXING]: 'Boxtraining',
  [ActivityTypeEnum.RUNNING]: 'Lauftraining',
  [ActivityTypeEnum.STRENGTH]: 'Krafttraining',
  [ActivityTypeEnum.OTHER]: 'Sonstige Trainingseinheit',
};

export function convertTimeIsoTimeToShort(isoTime: string): string {
  const date = new Date(isoTime);
  return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
}

export function convertTimeShortToIso(shortTime: string): string {
  const [hours, minutes] = shortTime.split(':').map(Number);
  const date = new Date();
  date.setHours(hours, minutes, 0, 0);
  return date.toISOString();
}
